var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.43,387.66c-4.26-.89-8.59-1.53-12.77-2.71C61.91,377.42,45,356.8,43.83,328.73c-1.22-29,2-57.59,13-84.74,7.12-17.54,17.45-32.7,34.77-42a68.4,68.4,0,0,1,34.13-8.2c3.78.08,7.76,2,11.22,3.87,5.56,3,10.71,6.78,16.11,10.11q47.09,29.07,94.15-.07c4.35-2.7,8.8-5.3,12.89-8.37,7.51-5.62,15.76-6.32,24.68-5,24.34,3.57,41.53,16.91,53.12,38.17,10.35,19,15,39.61,17.08,60.86a301.21,301.21,0,0,1,1.44,32.9C356,359,333.53,383.39,301,387a14.6,14.6,0,0,0-2.38.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.56,193.18c-50.35-.3-90.62-40.83-90.24-90.82a90.45,90.45,0,0,1,90.71-90c49,0,90.53,40.68,90.09,90.67C287.68,153.29,247.26,193.47,197.56,193.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUserFill);
export default __webpack_public_path__ + "static/media/Icons_User Fill.bdea6628f1382ba82197be04f5709994.svg";
export { ForwardRef as ReactComponent };